import type { RefObject } from 'preact';

export function injectRefToReactComponent<T>(ref: RefObject<T>) {
  return (reactRef: any) => {
    // eslint-disable-next-line no-param-reassign
    ref.current = reactRef?.$el ?? null;
  };
}
